import React, { useState, useEffect } from "react";
import { Title, Body } from "@vds/typography";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Loader } from "@vds/loaders";
import RuleDetails from "../../Rules/RuleDetails";
import RoiModal from "../../../global/components/Modals/RoiModals";
import AddAlertModal from "../../../global/components/Modals/RoiModals/AddAlertModal";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../../global/axiosInterceptor";
import { fetchVisionRulesEndPoint } from "../../../configuration";
import { fetchRulesSuccess } from "../../../store/actions";
import { fetchRules } from "../../../model/ruleService";

import { TextLink, TextLinkCaret, Button } from "@vds/buttons";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { Spinner } from "react-bootstrap";
import {
  CVAPP_PERSON_DETECTION,
  CVAPP_VEHICLE_DETECTION,
} from "../../../global/constants/cvappConstants";

const Rules = ({
  rulesLists,
  action,
  openRuleModal,
  isModalOpen,
  closeRuleModal,
  isModalRuleOpen,
  closeRuleRoiModal,
  cvAppName,
  roiResponse,
  cameraId,
  handleRuleResp,
  state,
  floorImage,
  cvappid,
  selectedRoiId,
  setSelectedRule,
  setRuleDetails,
  ruleDetails,
  selectedRule,
  EEAppName,
  setZoneType,
  zoneType,
  data,
  tagIds,
  loading = false,
}) => {

  const { activeSession } = useSelector((r) => r.sessionReducer.activeSession) || {};
  const { width: viewportWidth } = useWindowSize();
  const isSmallScreen = (viewportWidth ?? 1400) < 787;
  const [rulesLoading, setRulesLoading] = useState(false);
  const [fetchedRules, setFetchedRules] = useState([]);
  const [rulesError, setRulesError] = useState(false);
  const dispatch = useDispatch();

  const fetchRulesData = async () => {
    setRulesLoading(true);
    setRulesError(false);
    try {
      const accountId = activeSession?.accountId;

      const [rulesResponse, rulesResult] = await Promise.allSettled([
        axiosInstance.post(fetchVisionRulesEndPoint(), {
          accountname: accountId,
          filter: { $selection: { serviceid: cvappid } },
        }),
        fetchRules(activeSession),
      ]);

      const response = rulesResponse.status === 'fulfilled' ? rulesResponse.value : null;
      const resp = rulesResult.status === 'fulfilled' ? rulesResult.value : null;
      
      // Check if one or both APIs failed
      if (rulesResponse.status === 'rejected' || rulesResult.status === 'rejected') {
        setRulesError(true);
      }
      
      dispatch(fetchRulesSuccess(resp || []));
      const all = response?.data || [];
      const filtered = all.filter((item) => item?.aggregateRule === false);
      setFetchedRules(filtered);
    } catch (e) {
      console.error("Error fetching rules data", e);
      setRulesError(true);
    } finally {
      setRulesLoading(false);
    }
  };

  const openAlertFlow = async () => {
    setZoneType(EEAppName);
    openRuleModal();
    await fetchRulesData();
  };

  return (
    <>
      <div className="vision-roi-box-last" style={{ height: "60px" }}>
        <div
          style={{
            marginLeft: EEAppName ? "-15px" : "10px",
            paddingTop: "10px",
          }}
        >
          {!EEAppName && (
            <div className="vision-roi-col">
              <Title size="small" primitive="h2" viewport="desktop">
                Alerts
              </Title>
              {loading && <Spinner animation="border" variant="dark"  size="sm"/>}
              {rulesLists && rulesLists.length !== 0 && action === "update" && (
                <Button
                  size={isSmallScreen ? "small" : "large"}
                  disabled={false}
                  use="secondary"
                  data-testid="rules_addAlertButton"
                  onClick={openAlertFlow}
                >
                  Add Alert
                </Button>
              )}
            </div>
          )}

          { rulesLists &&
            rulesLists.length !== 0 && 
            <div
            // className="vision-roi-col"
            style={{
              paddingTop: "20px",
              maxHeight: "120px",
              minHeight: loading ? "40px" : undefined,
              height: "auto",
              paddingBottom: "10px",
              overflow: "auto",
              position: "relative",
            }}
          >
            <div className="rules-list-loader">
              <Loader active={loading} fullscreen={false} />
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                flexDirection: "column-reverse",
              }}
            >
              {rulesLists &&
                rulesLists.length !== 0 &&
                rulesLists.map((rule, index) => {
                  return (
                    <div
                      key={index}
                      title={
                        rule?.action === "create"
                          ? "Unsave Rules"
                          : rule?.ruleName
                          ? rule?.ruleName
                          : rule?.name
                      }
                      data-testid="rules_ruleTextLink"
                      className="vision-roi-textlink"
                    >
                      <TextLink 
                      type="standAlone" 
                       onClick={() => {
                        setSelectedRule(rule);
                        setRuleDetails(false);
                        setZoneType(EEAppName);
                        setTimeout(() => {
                          setRuleDetails(true);
                        }, 100);
                      }}
                      >
                        {rule?.ruleName ? rule?.ruleName : rule?.name}
                      </TextLink>
                    </div>
                  );
                })}
            </div>
          </div>}
          {rulesLists && rulesLists?.length !== 0 && action !== "update" && (
            <div>
              <Button
                size="small"
                // disabled={
                //   (cvAppName === CVAPP_PERSON_DETECTION ||
                //     cvAppName === CVAPP_VEHICLE_DETECTION) &&
                //   rulesLists?.length === 1
                // }
                use="secondary"
                data-testid="rules_addAlertButton"
                onClick={() => {
                  // openRuleModal();
                  openAlertFlow();
                  setZoneType(EEAppName);
                }}
              >
                Add Alert
              </Button>
            </div>
          )}
          <div
            style={{
              paddingTop: "20px",
              paddingBottom: "10px",
              bottom: "10px",
            }}
          >
            {rulesLists && !EEAppName && rulesLists.length === 0 && 
            
              <Button
                size={isSmallScreen ? "small" : "large"}
                disabled={false}
                use="primary"
                data-testid="rules_addAlertButton"
                onClick={openAlertFlow}
              >
                Add Alert
              </Button>
            }
            {isModalRuleOpen && zoneType === EEAppName && (
              <RoiModal
                isModalOpen={isModalRuleOpen}
                closeRuleModal={closeRuleRoiModal}
                cvApp={cvAppName}
                roiResponse={roiResponse}
                cameraId={cameraId}
                onApiCall={handleRuleResp}
                cameraName={state?.cameraName}
                videoSource={floorImage}
                cvappid={cvappid}
                roiid={selectedRoiId}
                areaName={state?.areaSelected}
                fovid={
                  Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId
                }
                companionid={state?.companionid ?? state?.companionId}
                EEAppName={EEAppName}
                data={data}
                tagIds={tagIds}
                mode={action}
              />
            )}
            {isModalOpen && zoneType === EEAppName && (
              <AddAlertModal
                isModalOpen={isModalOpen}
                closeRuleModal={closeRuleModal}
                cvApp={cvAppName}
                roiResponse={roiResponse}
                cameraId={cameraId}
                onApiCall={handleRuleResp}
                cameraName={state?.cameraName}
                videoSource={floorImage}
                cvappid={cvappid}
                roiid={selectedRoiId}
                areaName={state?.areaSelected}
                fovid={
                  Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId
                }
                companionid={state?.companionid ?? state?.companionId}
                EEAppName={EEAppName}
                tagIds={tagIds}
                fetchedRules={fetchedRules}
                loading={rulesLoading}
                rulesError={rulesError}
                handleRetry={fetchRulesData}
              />
            )}
          </div>
        </div>
      </div>
      {zoneType === EEAppName && (
        <Modal
          opened={ruleDetails}
          surface="light"
          width="980px"
          fullScreenDialog={false}
          disableAnimation={false}
          disableOutsideClick={false}
          ariaLabel="Testing Modal"
        >
          <ModalBody>
            <div>
              <RuleDetails
                ruleListInRoi={selectedRule}
                roiid={selectedRoiId}
                videoSource={floorImage}
                editRoiTagid={tagIds}
                setRuleDetails={setRuleDetails}
              />
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default Rules;